import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '@cm/core/localization';
import { Observable } from 'rxjs';

@Pipe({
	name: 'booleanDisplay',
	standalone: true,
})
export class BooleanDisplayPipe implements PipeTransform {
	constructor(private readonly locService: LocalizationService) {}

	transform(value?: string | boolean): Observable<string> {
		return this.locService.transformBooleanDisplay$(value);
	}
}
